import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export default function CheckoutForm({ cancelbtn, callbackUrl }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [orderIdObject, setorderIdObject] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const redirectStatus = urlParams.get('redirect_status');


    var addPayment = localStorage.getItem('add_payment');
    var addPaymentObject = JSON.parse(addPayment);
    var orderId = localStorage.getItem('orderId');
    setorderIdObject(JSON.parse(orderId));
    const clientSecret = new URLSearchParams(window.location.search).get(
      addPaymentObject
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        case "canceled":
          setMessage("Payment was canceled. Please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!stripe || !elements) {
      return;
    }
  
    // Show loading spinner before submitting payment
    Swal.fire({
      title: 'Saving, please wait',
      html: '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
      showConfirmButton: false,
      showCancelButton: false,
      focusConfirm: false,
    });
  
    setIsLoading(true);
  
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${process.env.REACT_APP_PUBLIC_URL + callbackUrl}`,
      },
    });
  
    if (error) {
      // If there is an error, show an error message
      setMessage(error.message);
    } else {
      setMessage("Payment successful!");
    }
  
    Swal.close();
    setIsLoading(false);
  };

  

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!stripe || !elements) {
  //     return;
  //   }


  //   Swal.fire({
  //     title: 'Saving, please wait',
  //     html:
  //       '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
  //     showConfirmButton: false,
  //     showCancelButton: false,
  //     focusConfirm: false,
  //   });

  //   setIsLoading(true);

  //   const { error } = await stripe.confirmPayment({
  //     elements,
  //     confirmParams: {
  //       return_url: `${process.env.REACT_APP_PUBLIC_URL + callbackUrl}`,
  //     },
  //   });

  //   if (error.type === "card_error" || error.type === "validation_error") {
  //     setMessage(error.message);
  //   } else {
  //     setMessage("An unexpected error occurred.");
  //   }
  //   Swal.close();
  //   setIsLoading(false);
  // };

  const paymentElementOptions = {
    layout: "tabs"
  }

  const handleCancel = async (orderIdObject) => {
    const data = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: "CancelPayment", order_id: orderIdObject },
    ).then(response => {
      if (response.data.status === true) {

        navigate(`/advertisement`);
      } else {
        Swal.fire(
          'Oops...m',
          `Something went wrong. ${response.data.message}`,
          'error'
        );
      }
    })
      .catch(error => {
        console.log(error)
      });
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>

      <PaymentElement id="payment-element" options={paymentElementOptions} />

      <button disabled={isLoading || !stripe || !elements} id="submit" className="btn btn-primary btn-lg mt-3">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
      {cancelbtn === true &&
        <button type="button" className="btn btn-secondary btn-lg ms-2 mt-3"
          onClick={() => handleCancel(orderIdObject)} disabled={isLoading}>
          Cancel Payment
        </button>
      }
      {/* Show any error or success messages */}
      {message && <div id="payment-message" className="text-danger">{message}</div>}
    </form>
  );
}